import { useState } from "react";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useModalContext } from "../../../Contexts/ModalContext";

import { modalVariants } from "../../../Utils/constants";

import "./mail-check.scss";

const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS",
  "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY",
  "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV",
  "WI", "WY",
];

export default function renderEditMailingAddress(modalContext, props) {
  const { updateModalComponent, pushModalStack, setModalVariant, setModalClassName, setModalTitle } = modalContext;

  updateModalComponent(() => <EditMailingAddress {...props} />);
  pushModalStack(() => renderEditMailingAddress(modalContext, props));
  setModalVariant(modalVariants.flexDialog);
  setModalClassName("mail-check-modal edit-mailing-address-modal align-title-left hide-back-button");
  setModalTitle("Edit mailing address");
}

const EditMailingAddress = ({ address, onSave }) => {
  const { popModalStack } = useModalContext();

  const [form, setForm] = useState({
    firstName: address?.firstName ?? "",
    lastName: address?.lastName ?? "",
    street: address?.street ?? "",
    apt: address?.apt ?? "",
    city: address?.city ?? "",
    state: address?.state ?? "",
    zip: address?.zip ?? "",
  });

  const setField = (field) => (event) => setForm((prev) => ({ ...prev, [field]: event.target.value }));

  const isValid = !!form.firstName && !!form.lastName && !!form.street && !!form.city && !!form.state && !!form.zip;

  const onSubmit = (event) => {
    event.preventDefault();
    if (!isValid) return;
    onSave?.(form);
    popModalStack(1);
  };

  return (
    <form className="ema-form" onSubmit={onSubmit} autoComplete="off">
      <div className="modal-dialog-content">
        <p className="ema-subtitle">This address will be printed on your check. Please verify it before saving.</p>

        <div className="ema-row">
          <div className="ema-field">
            <label className="ema-label" htmlFor="ema-first-name">First name</label>
            <input id="ema-first-name" className="ema-input" value={form.firstName} onChange={setField("firstName")} />
          </div>
          <div className="ema-field">
            <label className="ema-label" htmlFor="ema-last-name">Last name</label>
            <input id="ema-last-name" className="ema-input" value={form.lastName} onChange={setField("lastName")} />
          </div>
        </div>

        <div className="ema-field">
          <label className="ema-label" htmlFor="ema-street">Street address</label>
          <input id="ema-street" className="ema-input" value={form.street} onChange={setField("street")} />
        </div>

        <div className="ema-row">
          <div className="ema-field ema-field-narrow">
            <label className="ema-label" htmlFor="ema-apt">Apt / Suite</label>
            <input id="ema-apt" className="ema-input" value={form.apt} onChange={setField("apt")} />
          </div>
          <div className="ema-field">
            <label className="ema-label" htmlFor="ema-city">City</label>
            <input id="ema-city" className="ema-input" value={form.city} onChange={setField("city")} />
          </div>
        </div>

        <div className="ema-row">
          <div className="ema-field ema-field-narrow">
            <label className="ema-label" htmlFor="ema-state">State</label>
            <select id="ema-state" className="ema-input ema-select" value={form.state} onChange={setField("state")}>
              <option value="">--</option>
              {US_STATES.map((state) => (
                <option key={state} value={state}>{state}</option>
              ))}
            </select>
          </div>
          <div className="ema-field">
            <label className="ema-label" htmlFor="ema-zip">Zip code</label>
            <input id="ema-zip" className="ema-input" value={form.zip} onChange={setField("zip")} inputMode="numeric" maxLength={5} />
          </div>
        </div>
      </div>

      <div className="action-container split-equally">
        <PrimaryButton type="submit" disabled={!isValid}>
          Save address
        </PrimaryButton>
        <PrimaryButton className="secondary-colors" type="button" onClick={() => popModalStack(1)}>
          Cancel
        </PrimaryButton>
      </div>
    </form>
  );
};
